import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import {
  ControlPlaneCockpitClient,
  controlPlaneCockpitApiRef,
} from './cockpit/ControlPlaneCockpitApi';
import { ControlPlaneClient, controlPlaneApiRef } from './api';
import {
  activityCreationRouteRef,
  activityCockpitRouteRef,
  connectActivityRouteRef,
  frontierRootRouteRef,
  newActivityRouteRef,
  rootRouteRef,
} from './routes';

export const spassuCodeControlPlanePlugin = createPlugin({
  id: 'spassu-code-control-plane',
  routes: {
    root: rootRouteRef,
    newActivity: newActivityRouteRef,
    connectActivity: connectActivityRouteRef,
    activityCockpit: activityCockpitRouteRef,
  },
  externalRoutes: {
    activityCreation: activityCreationRouteRef,
    frontierRoot: frontierRootRouteRef,
  },
  apis: [
    createApiFactory({
      api: controlPlaneCockpitApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new ControlPlaneCockpitClient(discoveryApi, fetchApi),
    }),
    createApiFactory({
      api: controlPlaneApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new ControlPlaneClient(discoveryApi, fetchApi),
    }),
  ],
});

export const SpassuCodeControlPlanePage = spassuCodeControlPlanePlugin.provide(
  createRoutableExtension({
    name: 'SpassuCodeControlPlanePage',
    component: () =>
      import('./components/ControlPlanePage').then(
        module => module.ControlPlanePage,
      ),
    mountPoint: rootRouteRef,
  }),
);
